import { useQuery } from "@tanstack/react-query";
import type { DistributionDatum } from "../components/DistributionChart.tsx";

const NO_DATA: DistributionDatum[] = [];

/** A stats endpoint's items as DistributionChart data. */
export function useSourceStats<T>(
  queryKey: readonly unknown[],
  fetcher: () => Promise<{ items: T[] }>,
  map: (item: T) => DistributionDatum,
) {
  const { data, isLoading } = useQuery({
    queryKey,
    queryFn: fetcher,
    staleTime: 5 * 60_000,
    select: (res) => res.items.map(map),
  });
  return { chartData: data ?? NO_DATA, isLoading };
}
